/*
  Bonjour Diamond -- global JS entry point.
  Wires the fullscreen menu toggle and exposes window.BD = { openDrawer,
  closeDrawer } for the cart drawer (drawer markup lands in Task 15) plus the
  header's Bag button. Body scroll lock is the .bd-lock class (see base.css).
*/
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const menuBtn = $("[data-menu-toggle]"), panel = $("[data-menu-panel]");
  menuBtn?.addEventListener("click", () => {
    const open = panel.classList.toggle("is-open");
    menuBtn.setAttribute("aria-expanded", open);
    document.body.classList.toggle("bd-lock", open);
  });
  window.BD = {
    openDrawer(){ $("[data-cart-drawer]")?.classList.add("is-open"); document.body.classList.add("bd-lock"); },
    closeDrawer(){ $("[data-cart-drawer]")?.classList.remove("is-open"); document.body.classList.remove("bd-lock"); },
  };
  // Both the wide- and narrow-header Bag controls carry [data-cart-open] --
  // now real <a href="{{ routes.cart_url }}"> links so no-JS visitors reach
  // /cart -- so every match needs the listener, not just the first.
  $$("[data-cart-open]").forEach((el) =>
    el.addEventListener("click", (e) => { e.preventDefault(); window.BD.openDrawer(); }));

  // Product gallery -- delegated thumbnail click swaps the main image (Task 13).
  // Static gallery behaviour only; variant-driven price/option logic is Task 14's
  // product.js. Delegated on document so pages without a gallery are unaffected.
  document.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-thumb]");
    if (!thumb) return;
    const thumbs = $("[data-gallery-thumbs]");
    const img = $("[data-gallery-main] img");
    if (!thumbs || !img) return;
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.src = thumb.dataset.full;
    img.alt = thumb.dataset.alt || "";
    thumbs.querySelectorAll("[data-thumb]").forEach((t) => t.classList.toggle("is-active", t === thumb));
    // keep the active thumbnail in view (sideways only -- never moves the page)
    thumbs.scrollTo({ left: thumb.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - thumb.clientWidth) / 2, behavior: "smooth" });
  });

  // Product gallery -- full-screen viewer. Opens from the main image or the
  // magnifier button, shows the 2000px file ([data-zoom] on each thumbnail),
  // click / tap the image to zoom in and out, arrows / swipe to change image,
  // Esc or the backdrop to close. Built on first use.
  const galleryMain = $("[data-gallery-main]"), thumbsEl = $("[data-gallery-thumbs]");
  if (galleryMain && thumbsEl) {
    const thumbs = $$("[data-thumb]", thumbsEl);
    let box, stage, big, count, index = 0, opener = null;
    const active = () => Math.max(0, thumbs.findIndex((t) => t.classList.contains("is-active")));
    const swipe = (el, onSwipe, enabled = () => true) => {
      let x = 0, y = 0;
      el.addEventListener("touchstart", (e) => { x = e.touches[0].clientX; y = e.touches[0].clientY; }, { passive: true });
      el.addEventListener("touchend", (e) => {
        const dx = e.changedTouches[0].clientX - x, dy = e.changedTouches[0].clientY - y;
        if (enabled() && Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) onSwipe(dx < 0 ? 1 : -1);
      }, { passive: true });
    };
    const zoomed = () => big.classList.contains("is-zoomed");
    const fit = () => { big.classList.remove("is-zoomed"); big.style.width = ""; };
    const pan = (e) => {
      const r = stage.getBoundingClientRect();
      stage.scrollLeft = ((e.clientX - r.left) / r.width) * (stage.scrollWidth - stage.clientWidth);
      stage.scrollTop = ((e.clientY - r.top) / r.height) * (stage.scrollHeight - stage.clientHeight);
    };
    const show = (i) => {
      index = (i + thumbs.length) % thumbs.length;
      const t = thumbs[index];
      fit();
      big.src = t.dataset.zoom || t.dataset.full;
      big.alt = t.dataset.alt || "";
      count.textContent = `${index + 1} / ${thumbs.length}`;
    };
    const close = () => {
      box.classList.remove("is-open");
      document.body.classList.remove("bd-lock");
      thumbs[index]?.click();          // the page gallery follows the last image viewed
      opener?.focus?.();
    };
    const build = () => {
      box = document.createElement("div");
      box.className = "bd-lightbox";
      box.setAttribute("role", "dialog");
      box.setAttribute("aria-modal", "true");
      box.setAttribute("aria-label", "Image viewer");
      box.innerHTML = `<div class="bd-lightbox__stage"><img class="bd-lightbox__img" alt="" draggable="false"></div>
        <button type="button" class="bd-lightbox__btn bd-lightbox__close" aria-label="Close">&times;</button>
        <button type="button" class="bd-lightbox__btn bd-lightbox__nav bd-lightbox__nav--prev" aria-label="Previous image">&larr;</button>
        <button type="button" class="bd-lightbox__btn bd-lightbox__nav bd-lightbox__nav--next" aria-label="Next image">&rarr;</button>
        <div class="bd-lightbox__count" aria-live="polite"></div>`;
      document.body.appendChild(box);
      stage = $(".bd-lightbox__stage", box); big = $("img", box); count = $(".bd-lightbox__count", box);
      if (thumbs.length < 2) $$(".bd-lightbox__nav", box).forEach((b) => (b.hidden = true));
      $(".bd-lightbox__close", box).addEventListener("click", close);
      $(".bd-lightbox__nav--prev", box).addEventListener("click", () => show(index - 1));
      $(".bd-lightbox__nav--next", box).addEventListener("click", () => show(index + 1));
      stage.addEventListener("click", (e) => {
        if (e.target !== big) { close(); return; }
        if (zoomed()) { fit(); return; }
        const w = Math.min(2000, Math.max(big.getBoundingClientRect().width * 2, 1100));
        big.style.width = `${w}px`;
        big.classList.add("is-zoomed");
        pan(e);
      });
      stage.addEventListener("pointermove", (e) => { if (zoomed() && e.pointerType === "mouse") pan(e); });
      swipe(stage, (d) => show(index + d), () => !zoomed());
      box.addEventListener("keydown", (e) => {
        if (e.key === "Escape") close();
        else if (e.key === "ArrowLeft") show(index - 1);
        else if (e.key === "ArrowRight") show(index + 1);
        else if (e.key === "Tab") {
          const f = $$("button:not([hidden])", box), i = f.indexOf(document.activeElement);
          e.preventDefault();
          f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
        }
      });
    };
    const open = () => {
      if (!thumbs.length) return;
      if (!box) build();
      opener = document.activeElement;
      show(active());
      box.classList.add("is-open");
      document.body.classList.add("bd-lock");
      $(".bd-lightbox__close", box).focus();
    };
    galleryMain.addEventListener("click", open);
    // On touch screens a sideways swipe over the main image moves to the next / previous one.
    if (thumbs.length > 1) swipe(galleryMain, (d) => thumbs[(active() + d + thumbs.length) % thumbs.length].click());
  }

  // Collection filter / sort menus (<details class="bd-filter">): one open at
  // a time, closed by an outside click or Esc. The links are plain URLs, so
  // everything works without this script; it also puts the page back where
  // it was after a filter link reloads it.
  const menus = $$("details.bd-filter");
  if (menus.length) {
    menus.forEach((d) => d.addEventListener("toggle", () => {
      if (d.open) menus.forEach((o) => { if (o !== d) o.open = false; });
    }));
    document.addEventListener("click", (e) => {
      if (!e.target.closest("details.bd-filter")) menus.forEach((d) => (d.open = false));
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") menus.forEach((d) => (d.open = false));
    });
    const bar = $("[data-filterbar]");
    try {
      const saved = sessionStorage.getItem("bd-filter-scroll");
      sessionStorage.removeItem("bd-filter-scroll");
      if (saved !== null && bar) window.scrollTo(0, Math.min(+saved, bar.getBoundingClientRect().top + window.scrollY - 90));
      bar?.addEventListener("click", (e) => {
        if (e.target.closest("a")) sessionStorage.setItem("bd-filter-scroll", String(window.scrollY));
      });
    } catch (err) { /* storage unavailable: the page simply opens at the top */ }
  }

  // Search panel (snippets/search-panel.liquid): the magnifier opens it and
  // results appear as you type, without leaving the page. What is typed goes
  // to the store's search page, asked to render only sections/search-inline.
  const panelEl = $("[data-search]");
  if (panelEl) {
    const input = $("[data-search-input]", panelEl), results = $("[data-search-results]", panelEl), idle = $("[data-search-idle]", panelEl);
    let timer = 0, ctrl = null, last = "", opener = null;
    const parse = (html) => new DOMParser().parseFromString(html, "text/html").querySelector("[data-search-inline]");
    const ask = (url) => {
      const u = new URL(url, location.origin);
      u.searchParams.set("section_id", "search-inline");
      ctrl?.abort();
      ctrl = new AbortController();
      panelEl.classList.add("is-loading");
      return fetch(u, { signal: ctrl.signal })
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(r.status))))
        .then(parse)
        .finally(() => panelEl.classList.remove("is-loading"));
    };
    // While typing, wait for three letters (shorter words match nothing); Enter searches whatever is there.
    const run = (force) => {
      const q = input.value.trim();
      if (q === last && !force) return;
      last = q;
      if (!q || (q.length < 3 && !force)) { ctrl?.abort(); results.innerHTML = ""; idle.hidden = false; return; }
      const u = new URL(panelEl.dataset.url, location.origin);
      u.searchParams.set("q", q);
      u.searchParams.set("type", "product,page");
      u.searchParams.set("options[prefix]", "last");
      ask(u)
        .then((fresh) => { results.innerHTML = fresh ? fresh.innerHTML : ""; idle.hidden = true; $(".bd-searchpanel__body", panelEl).scrollTop = 0; })
        .catch((err) => {
          if (err.name === "AbortError") return;
          last = "";
          results.innerHTML = '<p class="bd-search__empty">Search is not answering just now. Press Enter to try again.</p>';
        });
    };
    const openSearch = () => {
      opener = document.activeElement;
      $("[data-menu-panel]")?.classList.remove("is-open");                      // inner-page menu
      $("[data-menu-toggle]")?.setAttribute("aria-expanded", "false");
      $$("details.kh-mobile-menu[open]").forEach((d) => (d.open = false));    // home-page menu
      panelEl.classList.add("is-open");
      document.body.classList.add("bd-lock");
      input.focus();
      input.select();
    };
    const closeSearch = () => {
      panelEl.classList.remove("is-open");
      document.body.classList.remove("bd-lock");
      opener?.focus?.();
    };
    document.addEventListener("click", (e) => {
      if (e.target.closest("[data-search-open]")) { e.preventDefault(); openSearch(); return; }
      if (e.target.closest("[data-search-close]")) { closeSearch(); return; }
      const term = e.target.closest("[data-search-term]");
      if (term) { input.value = term.dataset.searchTerm; input.focus(); run(true); return; }
      const more = e.target.closest("[data-search-more]");
      if (more) {
        e.preventDefault();
        ask(more.href).then((fresh) => {
          const grid = $("[data-search-grid]", results), pages = $("[data-search-pages]", results);
          const freshGrid = fresh && $("[data-search-grid]", fresh), freshPages = fresh && $("[data-search-pages]", fresh);
          if (freshPages) pages ? pages.append(...freshPages.children) : (grid || more.parentElement).before(freshPages);
          if (freshGrid) grid ? grid.append(...freshGrid.children) : more.parentElement.before(freshGrid);
          const next = fresh && $("[data-search-more]", fresh);
          if (next) more.href = next.href; else more.parentElement.remove();
        }).catch(() => {});
      }
    });
    input.addEventListener("input", () => { clearTimeout(timer); timer = setTimeout(() => run(false), 240); });
    $("[data-search-form]", panelEl).addEventListener("submit", (e) => { e.preventDefault(); clearTimeout(timer); run(true); input.blur(); });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && panelEl.classList.contains("is-open")) closeSearch();
    });
  }
})();
